import { render } from "./BatchProductEntry.vue?vue&type=template&id=1bc22fce&scoped=true"
import script from "./BatchProductEntry.vue?vue&type=script&lang=js"
export * from "./BatchProductEntry.vue?vue&type=script&lang=js"

import "./BatchProductEntry.vue?vue&type=style&index=0&id=1bc22fce&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1bc22fce"]])

export default __exports__